import { LUDUM_USER_ROLES } from '@/constants';
const { ATHLETE, HEAD_COACH, COACH, MANAGER } = LUDUM_USER_ROLES;

export function isAthlete(roleId) {
    return roleId === ATHLETE;
}

export function isCoach(roleId) {
    return [HEAD_COACH, COACH].includes(roleId);
}

export function isManager(roleId) {
    return roleId === MANAGER;
}
